import React from 'react';
import { motion } from 'framer-motion';
export function ProductSection() {
  const items = [{
    title: 'Ebook Principal Protocolo Silencio 11PM',
    desc: 'El sistema paso a paso para reprogramar tu respuesta cerebral al ruido.'
  }, {
    title: 'Técnica del Tamborileo Suboccipital',
    desc: 'El ejercicio físico de 60 segundos que reduce la percepción del volumen de inmediato.'
  }, {
    title: 'La Auditoría de Habitación Silenciosa',
    desc: 'Cómo configurar tu entorno para que el tinnitus se disuelva en el fondo.'
  }, {
    title: 'Protocolo de Emergencia 3 A.M.',
    desc: 'Exactamente qué hacer si te despiertas en pánico para volver a dormir en minutos.'
  }, {
    title: 'Checklist de la Dieta del Ruido',
    desc: "Los 3 disparadores químicos que debes eliminar después de las 6 PM para evitar 'picos' de sonido."
  }];
  return <section className="py-16 md:py-24 px-5 md:px-8 bg-[#0d1222] border-y border-[#1a1f3a]" data-id="element-111">
      <div className="max-w-4xl mx-auto" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-113">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-114">
            Lo que obtienes hoy
          </h2>
          <div className="w-24 h-1 bg-[#d4a853] mx-auto rounded-full" data-id="element-115"></div>
        </motion.div>

        <div className="space-y-6" data-id="element-116">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-[#1a1f3a] p-6 md:p-8 rounded-xl border border-[#2a3150] flex flex-col md:flex-row gap-4 md:items-center hover:border-[#d4a853]/50 transition-colors" data-id="element-117">
              <div className="flex-shrink-0 w-12 h-12 bg-[#d4a853]/10 rounded-full flex items-center justify-center border border-[#d4a853]/30" data-id="element-118">
                <span className="text-[#d4a853] font-bold text-xl" data-id="element-119">✓</span>
              </div>
              <div data-id="element-120">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-121">
                  {item.title}
                </h3>
                <p className="text-gray-400" data-id="element-122">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}